import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "usa_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleConsent = (value) => {
    localStorage.setItem(COOKIE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full z-[9999] flex justify-center px-2 py-4 bg-white border-t border-gray-200 shadow-lg animate-fade-in">
      <div className="w-full max-w-5xl flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center gap-2 mb-1">
            <span role="img" aria-label="cookie" className="text-2xl">🍪</span>
            <span className="font-semibold text-lg text-[#0a3c6e]">We respect your privacy</span>
          </div>
          <span className="text-gray-500 text-sm md:text-base">
            We use cookies to personalize your experience. Please check our {" "}
            <Link to="/privacy" className="text-[#1176c9] underline hover:text-[#0a3c6e]">Privacy Policy</Link> for more information.
          </span>
        </div>
        <div className="flex items-center gap-2 mt-2 md:mt-0">
          <button
            className="font-semibold px-6 py-2 rounded-full bg-white text-[#061c3d] border border-[#061c3d] hover:bg-gray-100 transition"
            onClick={() => handleConsent("rejected")}
          >
            Reject
          </button>
          <button
            className="font-semibold px-6 py-2 rounded-full bg-[#061c3d] text-white hover:bg-[#0a2a5c] transition"
            onClick={() => handleConsent("essential")}
          >
            Essential Only
          </button>
          <button
            className="font-semibold px-6 py-2 rounded-full bg-[#061c3d] text-white hover:bg-[#0a2a5c] transition"
            onClick={() => handleConsent("all")}
          >
            Accept All
          </button>
          <button
            className="ml-2 text-gray-400 hover:text-gray-700 text-xl px-2"
            onClick={() => handleConsent("closed")}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
